import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	upgradeButton: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.upgrade-button.upgrade-button',
		defaultMessage: 'Upgrade',
		description:
			'Log in button for standard or free customers to upgrade to premium to use the virtual service agent.',
	},
	viewPricingPlansButton: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.upgrade-button.view-pricing-plans-button',
		defaultMessage: 'View pricing and plans',
		description: 'Button to take users to pricing and plans page. Shown to non site admins.',
	},
});
